import React from 'react'
const SpaContext = React.createContext()
export default SpaContext